import { ArrowElbowDownLeftIcon, GearIcon, PackageIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Kbd } from '@reveni-io/reveni-ui'

import { categories } from '../constants'
import * as Styles from './styles'

const categoryIcons = {
  [categories.shipments]: PackageIcon,
  [categories.returns]: ArrowElbowDownLeftIcon,
  [categories.settings]: GearIcon,
}

const SearchResultItem = ({ result, active, onClick, onMouseEnter }) => {
  const theme = useTheme()
  const Icon = result.Icon || categoryIcons[result.category] || GearIcon

  return (
    <Styles.Container active={active} onClick={onClick} onMouseEnter={onMouseEnter} data-testid="search-result-item">
      <Styles.IconContainer>
        <Icon size={18} color={theme.colors.text.subtle} />
      </Styles.IconContainer>
      <Styles.TextContainer>
        <Styles.Title>{result.title}</Styles.Title>
        {result.subtitle && <Styles.Subtitle>{result.subtitle}</Styles.Subtitle>}
      </Styles.TextContainer>
      {result.status && <Styles.StatusBadge>{result.status}</Styles.StatusBadge>}
      {active && <Kbd>↵</Kbd>}
    </Styles.Container>
  )
}

export default SearchResultItem
